import {
  BiChartType,
  BiLegendPosition,
  BiVizStyle,
  BiVizType,
} from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
} from './biGalleryFields';

const shares: [string, number][] = [
  ['常规保养', 142700],
  ['钣金喷漆', 81600],
  ['轮胎更换', 48000],
  ['美容洗护', 26300],
  ['电瓶更换', 12400],
];
const brands: [string, number][] = [
  ['大众', 412],
  ['丰田', 268],
  ['本田', 197],
  ['宝马', 121],
  ['奔驰', 94],
  ['奥迪', 63],
  ['日产', 38],
  ['别克', 21],
  ['福特', 14],
  ['马自达', 9],
  ['沃尔沃', 6],
  ['其他', 4],
];

const sharesResult = galleryResult(
  [f.serviceType, f.revenue],
  shares.map(([type, yuan]) => [type, cents(yuan)]),
);

function shareCard(
  type: BiChartType,
  style?: BiVizStyle,
): BiGalleryDashboardCard {
  return {
    surface: 'dashboard',
    title: '本月营收构成',
    viz: {
      type,
      x: f.serviceType.key,
      series: [{ key: f.revenue.key }],
      ...(style ? { style } : {}),
    },
    data: galleryReady(sharesResult),
    rows: 5,
  };
}

const donut = shareCard(BiVizType.Donut);

export const kPieCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.Pie,
  name: '饼图 / 环形图',
  description: '百分比标签、内半径、大量小切片',
  preview: donut,
  variants: [
    { key: 'pie', name: '饼图', card: shareCard(BiVizType.Pie) },
    {
      key: 'pie-percent',
      name: '百分比标签',
      note: 'pie.showPercent = true',
      card: shareCard(BiVizType.Pie, {
        pie: { innerRadius: 0, showPercent: true },
      }),
    },
    {
      key: 'pie-values',
      name: '数值标签',
      note: 'dataLabels = true',
      card: shareCard(BiVizType.Pie, { dataLabels: true }),
    },
    {
      key: 'donut',
      name: '环形图',
      note: '默认内半径 0.6，中心为合计',
      card: donut,
    },
    {
      key: 'donut-thin',
      name: '内半径 0.3',
      note: 'pie.innerRadius = 0.3',
      card: shareCard(BiVizType.Donut, {
        pie: { innerRadius: 0.3, showPercent: true },
      }),
    },
    {
      key: 'donut-wide',
      name: '内半径 0.8',
      note: 'pie.innerRadius = 0.8',
      card: shareCard(BiVizType.Donut, {
        pie: { innerRadius: 0.8, showPercent: false },
      }),
    },
    {
      key: 'many-slices',
      name: '大量小切片',
      note: '12 个品牌，小于 4% 的切片不写字',
      card: {
        surface: 'dashboard',
        title: '到店车辆品牌分布',
        viz: {
          type: BiVizType.Pie,
          x: f.brand.key,
          series: [{ key: f.orders.key }],
          style: { pie: { innerRadius: 0, showPercent: true } },
        },
        data: galleryReady(galleryResult([f.brand, f.orders], brands)),
        rows: 6,
      },
    },
    {
      key: 'coded',
      name: '编码值切片',
      note: '工单状态：代码显示为中文，未登记的代码 legacy 原样显示',
      card: {
        surface: 'dashboard',
        title: '本月工单状态',
        viz: {
          type: BiVizType.Donut,
          x: f.orderStatus.key,
          series: [{ key: f.orders.key }],
          style: { pie: { innerRadius: 0.6, showPercent: true } },
        },
        data: galleryReady(
          galleryResult(
            [f.orderStatus, f.orders],
            [
              ['finished', 640],
              ['inprogress', 38],
              ['pending', 16],
              ['cancelled', 18],
              ['legacy', 3],
            ],
          ),
        ),
        rows: 5,
      },
    },
    {
      key: 'side-legend',
      name: '图例右侧',
      note: 'legend.position = right',
      card: shareCard(BiVizType.Donut, {
        legend: { show: true, position: BiLegendPosition.Right },
      }),
    },
  ],
};
